/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-prototype-builtins */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-edit-prompt',
  templateUrl: './edit-prompt.component.html',
  styleUrls: ['./edit-prompt.component.scss'],
})
export class EditPromptComponent  implements OnInit {
  
  @Input() editable: boolean = false;  
  @Input() content: string = '';  
  @Input() promptType:string=''
  @Output() contentChange: EventEmitter<{ content?: string, action?: boolean }> = new EventEmitter();  
  constructor(private us:UtilsService) { 

  }
  isEditing: boolean = true;
  text:any;
  invalidPrompt:boolean=false;
  errMsg:string=""
  oldText:string=""
  

  ngOnInit() {
    this.text=this.content;
    this.oldText=this.text
    
    if(this.promptType==='LLM Response' || this.promptType==='Similarity Results'){
this.text=JSON.parse(this.text)
    }
  }

  submit(){
    if(this.promptType==='LLM Prompt'){
    if(this.isValidJSON(this.text)){
    this.content=this.text;
    if(this.isValidPrompt(this.text)){
      this.us.generatedPrompt=this.content
      this.contentChange.emit({action:true,content:this.content});
      this.errMsg=""
      this.invalidPrompt=false
    }
    else{
        this.errMsg="Invalid format: The keys must be 'role' and 'content', and the 'role' should be one of the following values: 'system', 'assistant', or 'user'"
        this.invalidPrompt=true
      }
    }
    else{

      this.errMsg="Invalid Json format"
      this.invalidPrompt=true
    }
  }
  else if(this.promptType==='SQL Prompt'){
    this.content=this.text;

    this.contentChange.emit({action:true,content:this.content});
  }
  else if(this.promptType==='Question'){
    this.content=this.text;
    this.us.updatedChatMessages=this.us.updatedChatMessages.map((item) => {
      if (item.question === this.us.generatedQuestion) {
        return { ...item, question: this.content };
      }
      return item; 
    });
    this.us.updatedChatMessages=this.us.updatedChatMessages.map((item) => {
      if (item.question === this.us.generatedQuestion) {
        return { ...item, question: this.content };
      }
      return item; 
    });
    // this.us.generatedQuestion=this.content;
    this.contentChange.emit({action:true,content:this.content});
  }
 
  
  }
  cancel(){
   this.text=this.oldText
  }
  close(){
    this.contentChange.emit({action:false});
  }
  onInput(event: Event): void {
    const target = event.target as HTMLElement;
    if (target) {
      this.text = target.innerText;
    }
  }
  isValidJSON(text: string): boolean {
    try {
      JSON.parse(text); 
      return true; 
    } catch (error) {
      return false; 
    }
  }
  isValidPrompt(text: string): boolean {
    const allowedRoles = ['system', 'assistant', 'user'];
  
    try {
      const parsedText = JSON.parse(text);
  
      
      if (!Array.isArray(parsedText)) {
        this.errMsg = "Invalid format: The prompt must be an array of objects.";
        return false;
      }
  
      
      for (const item of parsedText) {
        if (!item.hasOwnProperty('role') || !item.hasOwnProperty('content')) {
          this.errMsg = "Invalid format: The keys must be 'role' and 'content'.";
          return false;
        }
  
        
        if (!allowedRoles.includes(item.role)) {
          this.errMsg = "Invalid format: The 'role' must be one of the following values: 'system', 'assistant', or 'user'.";
          return false;
        }
  
        
        if (typeof item.content !== 'string' || item.content.trim() === '') {
          this.errMsg = "Invalid format: 'content' should be a non-empty string.";
          return false;
        }
      }
  
      
      return true;
    } catch (error) {
      this.errMsg = "Invalid format: The keys must be 'role' and 'content', and the 'role' should be one of the following values: 'system', 'assistant', or 'user'";
      return false;
    }
  }
  

}
